import api from "@/api";

export default {
  /**
   * Gửi báo cáo công việc (Lấy hàng / Giao hàng)
   * Payload: { type, mode, xeId, locationName, photos, startTime, ... }
   */
  submitJob(payload) {
    return api.post("/driver/jobs", payload);
  },

  /**
   * Lấy lịch sử (cho Admin hoặc Tài xế)
   */
  getHistory(params) {
    // params: { taiXeId, isAdmin, month, year }
    return api.get("/driver/jobs/history", { params });
  },
};
